import React from 'react';
import { SectionTitle, ColorSwatch, SliderRow } from './ui-primitives';
import { FrameThumb } from './canvas-previews';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
const FRAME_TYPES = [
    'none',
    'simple',
    'rounded',
    'label-bottom',
    'label-top',
    'badge',
    'ticket',
    'corners',
    'speech',
    'neon',
    'double',
];
export function FramePanel({ settings, update }) {
    const hasLabel = ['label-bottom', 'label-top', 'badge', 'ticket'].includes(settings.frame);
    return (<div className="space-y-4">
            <SectionTitle>Frame Style</SectionTitle>
            <div className="grid grid-cols-4 gap-1.5">
                {FRAME_TYPES.map((type) => (<FrameThumb key={type} type={type} selected={settings.frame === type} accentColor={settings.frameColor} onClick={() => update('frame', type)}/>))}
            </div>

            {settings.frame !== 'none' && (<div className="space-y-3 pt-2">
                    <SectionTitle>Frame Colors</SectionTitle>
                    <ColorSwatch color={settings.frameColor} label="Frame Color" onChange={(v) => update('frameColor', v)}/>
                    {hasLabel && (<ColorSwatch color={settings.frameTextColor} label="Text Color" onChange={(v) => update('frameTextColor', v)}/>)}
                </div>)}

            {hasLabel && (<div className="space-y-3">
                    <SectionTitle>Label</SectionTitle>
                    <div className="space-y-1.5">
                        <Label className="text-xs text-muted-foreground">Label Text</Label>
                        <Input value={settings.frameLabel} onChange={(e) => update('frameLabel', e.target.value)} maxLength={32} placeholder="SCAN ME" className="h-8 text-sm"/>
                    </div>
                    <SliderRow label="Font Size" value={settings.frameLabelSize} min={0.03} max={0.09} step={0.005} onChange={(v) => update('frameLabelSize', v)} display={settings.frameLabelSize.toFixed(3)}/>
                </div>)}
        </div>);
}
